import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SpamRowOption"*/ './lazyIndex')
);

export { default as initSpamOption } from './utils/initSpamScenarioOption';
export { default as isSpamOptionDirty } from './utils/isSpamOptionDirty';
export { default as getSpamList } from './utils/getSpamList';
export { default as saveSpamOption } from './actions/saveSpamOption';
export { default as SpamOptionFull } from './components/SpamOptionFull';
export { createSpamStore } from './actions/spamListMutatorActions';
export { SpamScenarioId } from 'owa-junkmail-configuration';

// Lazy-load actions
export let lazyAddToSpamList = new LazyAction(lazyModule, m => m.addToSpamList);
